import React, {useEffect} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {Exist, Footer, Questions, ScrollCTA, SquadsList, LanguageSwitch} from "components";
import {useStore} from "modules/hooks";
import {createConnextraScriptTag, ConnextraType} from "modules/utils";
import {SSOAdditionalFieldsModal} from "components/Modal/SSOAdditionalFieldsModal";
import {RequestState} from "modules/enums";
import {PagePreloader} from "components/Preloader";

const Container = styled.div`
	position: relative;
	z-index: 1;
`;

const Home: React.FC = observer(() => {
	const {I18n, UIQuestionsProgress, user} = useStore();
	const {isShowResultPage} = UIQuestionsProgress;

	useEffect(() => {
		void Promise.all([I18n.request(), user.request()]);

		createConnextraScriptTag(ConnextraType.HOME);
	}, [I18n, user]);

	if (user.apiState === RequestState.Requested) {
		return <PagePreloader />;
	}

	return (
		<div>
			{/*<Header />*/}
			<Container>
				<LanguageSwitch />
				<SquadsList />
				<Questions />
				<ScrollCTA />
			</Container>
			<Exist when={isShowResultPage}>
				<Footer />
			</Exist>
			<SSOAdditionalFieldsModal />
		</div>
	);
});

export default Home;
